// extracted by mini-css-extract-plugin
export default {"btnUpload":"UploadButton_btnUpload__euC5x"};